var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.jobDetailInfo)?_c('JobDetailRender',{attrs:{"isPreview":false,"jobDetailInfo":_vm.jobDetailInfo,"jobAndCompanyInfo":_vm.jobAndCompanyInfo}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }